import { DateTimeField, useLocale } from "@dgs/core";
import { format } from "date-fns";
import { useField } from "formik";
import { useTranslation } from "react-i18next";
import { TimezoneSingleSelectField } from "../../ui/TimezoneSingleSelectField";

export function EventDateTimeFields() {
	const { t } = useTranslation();
	const [{ value: startDate }, ,] = useField<string>("start");
	const { setTimeZone } = useLocale();
	return (
		<>
			<TimezoneSingleSelectField
				name="timezone"
				label={t("Timezone")}
				required={true}
				onChange={(e) => e.target.value && setTimeZone(e.target.value as string)}
			/>
			<DateTimeField name="start" label={t("Start")} required={true} showTimeZone />
			<DateTimeField
				name="end"
				label={t("End")}
				required={true}
				min={format(startDate, "yyyy-MM-dd'T'HH:mm")}
				showTimeZone
			/>
		</>
	);
}
